/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

const jwt = require("jsonwebtoken");

export interface IURLMethods extends IPluginMethodMap {
  parseURL(args: any): Promise<any>;
  decodeToken(args: { token: string; signerPK: string }): Promise<any>;
  parseAndDecodeToken(args: { signerPK: string }): Promise<any>;
}

export class URLService implements IAgentPlugin {
  readonly methods: IURLMethods;

  constructor() {
    this.methods = {
      parseURL: this.parseURL.bind(this),
      decodeToken: this.decodeToken.bind(this),
      parseAndDecodeToken: this.parseAndDecodeToken.bind(this),
    };
  }

  async parseURL() {
    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token");
    if (token) {
      token = String(token).trim();
    }
    return {
      token,
    };
  }

  async decodeToken(args: { token: string; signerPK: string }) {
    try {
      return jwt.verify(args.token, args.signerPK);
    } catch (err) {
      console.log("error in verifying token", err?.message);
      return null;
    }
  }

  async parseAndDecodeToken(args: { signerPK: string }) {
    let parsedToken, decoded;
    const { token } = await this.parseURL();
    if (token) {
      parsedToken = token;
      decoded = await this.decodeToken({
        token,
        signerPK: args.signerPK,
      });
    }
    return {
      token: parsedToken,
      decoded: decoded,
    };
  }
}
